import React from 'react';
import styled from 'styled-components';

import { Text } from '../../components/typography';
import { showWarningModal } from '../../components/modal';

export const showGenericUnknownCardProviderModal = ({ description }: { description?: string }) => {
  showWarningModal({
    title: 'Oops! Something Went Wrong',
    content: description && <MessageComponent {...{ description }} />
  });
};

const MessageComponent = ({ description }: { description: string }) => {
  return (
    <TextWrapper size="lg" weight="bold">
      {description}
    </TextWrapper>
  );
};

const TextWrapper = styled(Text)`
  margin-top: 1rem;
`;

export const forTestsOnly = {
  MessageComponent
};
